(function() {

/* 
     * BLOXException handler
     *
     * @listens BLOXException
     * @event dataLayer#Application Exception
     */
    window.addEventListener('BLOXException', function(ev) {
        console.log('Caught BLOXException', ev);
    });

})();